import React, { Component } from 'react';

import avatarIcon from './sw-av-login-avatar.png';
import addIcon from './sw-av-login-add.png';

import styles from './EmailList.module.css';

class EmailItem extends Component {
  handleEmailSelect = () => {
    this.props.onSelect(this.props.email);
  };

  render() {
    const { email } = this.props;

    return (
      <div className={styles.item} onClick={this.handleEmailSelect}>
        <img src={avatarIcon} alt="" />
        <span>{email}</span>
      </div>
    );
  }
}

const EmailList = ({ emails, onSelect, onSelectAnother }) => (
  <div className="boxed-container">
    <div className="invite">Select an email address</div>
    <div>
      {emails.map(email => (
        <EmailItem key={email} email={email} onSelect={onSelect} />
      ))}
      <div className={styles.item} onClick={onSelectAnother}>
        <img src={addIcon} alt="" />
        <span>Use another account</span>
      </div>
    </div>
  </div>
);

export default EmailList;
